export const GIFTS_GET_DESTINATIONS = 'GIFTS_GET_DESTINATIONS';
export const GIFTS_GET_ORIGINS_WITH_DESTINATIONS = 'GIFTS_GET_ORIGINS_WITH_DESTINATIONS';
export const GIFTS_GET_SELECTED_ORIGIN = "GIFTS_GET_SELECTED_ORIGIN";
export const GIFTS_GET_SELECTED_DESTINATION = 'GIFTS_GET_SELECTED_DESTINATION';
export const GIFTS_GET_SELECTED_DESTINATION_ORIGINS = 'GIFTS_GET_SELECTED_DESTINATION_ORIGINS';
export const GIFTS_GET_SELECTED_DESTINATION_BASE_PRICE = 'GIFTS_GET_SELECTED_DESTINATION_BASE_PRICE';
export const GIFTS_GET_SELECTED_DESTINATION_FINAL_PRICE = 'GIFTS_GET_SELECTED_DESTINATION_FINAL_PRICE';
export const GIFTS_FIND_DESTINATION_FROM_SLUG = 'GIFTS_FIND_DESTINATION_FROM_SLUG';

